import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './donate_button.less'
import { getI18n } from 'client/i18n'
import { Link } from 'react-router'
import { orange300, Button } from '@paypalcorp/pp-react'
import { trackClick } from '../../../../lib/fpti_analytics'

const i18n = getI18n('components/donate_button')

class DonateButton extends React.Component {
  static propTypes = {
    secondary: PropTypes.bool,
    reversed: PropTypes.bool,
    small: PropTypes.bool,
    preview: PropTypes.bool,
    canChipIn: PropTypes.bool,
    onClick: PropTypes.func,
    donateHref: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fullPageRefresh: PropTypes.bool,
    isOwner: PropTypes.bool,
    noCurrencyBalance: PropTypes.bool,
  }

  handleClick = e => {
    if (
      !this.props.canChipIn ||
      this.props.noCurrencyBalance ||
      this.props.preview
    ) {
      e.preventDefault()
    }
    if (this.props.onClick) {
      trackClick({
        clickName: 'donate',
      })
      this.props.onClick(e)
    }
  }

  render() {
    let linkProps = {}
    if (this.props.fullPageRefresh) {
      linkProps = { as: 'a', href: this.props.donateHref }
    } else {
      linkProps = { as: Link, to: this.props.donateHref }
    }

    return (
      <Button
        {...linkProps}
        secondary={this.props.secondary}
        inverse={this.props.reversed}
        small={this.props.small}
        data-pa-click="donate"
        data-nemo="donate"
        style={{ backgroundColor: orange300 }}
        styleName={`donate-button ${this.props.preview ? 'preview' : ''}`}
        onClick={this.handleClick}
      >
        {this.props.canChipIn ? i18n('donate') : i18n('ended')}
      </Button>
    )
  }
}

export default cssModules(DonateButton, styles, { allowMultiple: true })
